<template>
  <div :class="`suite-card-${suiteChatRoom.id}`">
    <div class='attendee-suite-card'>
      <div class='cover-img-container'>
        <img v-if='suiteChatRoom.cover_image_url' v-bind:src="suiteChatRoom.cover_image_url" class='cover-img' />
      </div>
      <div class='suite-card-body' v-bind:class="{ collapsed: collapsed }">
        <div class='suite-card-header'>
          <div class='suite-card__title' :class='[suiteChatRoom.chat_room_id ? "col-md-8" : "col-12"]'>
            {{ suiteChatRoom.name }}
          </div>
          <div class='suite-card__button col-md-4' v-if="suiteChatRoom.chat_room_id">
            <a class='suite-card__button-link' v-bind:href="chatRoomLink" v-if="suiteChatRoom.chat_room_id">
              <button class='btn btn-primary join-room-btn' v-bind:class="{ collapsedBtn: collapsed }">
                {{ this.suiteChatRoom.button_text ? this.suiteChatRoom.button_text : lang.get('event_strings.networking-suites.join_now_button') }}
              </button>
            </a>
          </div>
        </div>
        <div class='d-flex flex-row suite-content'>
          <!-- 2 column layout for showing capacity -->
          <div class='left-col col-sm-5 border-right' v-if="showRoomCapacity">
            <div v-html="suiteChatRoom.description" class='p-1 suite-card__description'>
            </div>
          </div>

          <div class='right-col col-sm-7 p-2' v-if="showRoomCapacity">
            <div class='d-flex flex-column suite-card__capacity' v-if="showRoomCapacity">
              <h4 class="suite-card__capacity-title">{{ lang.get('event_strings.networking-suites.capacity_title') }}</h4>
              <div class="progress room-capacity-bar">
                <div class="progress-bar" role="progressbar" v-bind:style="widthStyle">
                </div>
              </div>
              <div class='spots-available'>
                {{ lang.get('event_strings.networking-suites.capacity_status', {'active': (suiteChatRoom.chat_room.max_connections - suiteChatRoom.active_connections), 'roommax':suiteChatRoom.chat_room.max_connections}) }}
              </div>
            </div>

            <div class='d-flex flex-column suite-card-attendees-container' v-if='!collapsed'>
              <h4 class="suite-card__attendees-title">{{ lang.get('event_strings.networking-suites.attendees_title') }}</h4>
              <span v-if="subscribingToPresenceChannel">
                {{ lang.get('event_strings.networking-suites.connecting_label') }}
              </span>
              <span v-if="subscribedToPresenceChannel">
                <div class='d-flex align-items-center suite-attendee-item mb-1' v-for="(user, i) in connectedUsers" :key="i">
                  <avatar-bubble v-bind:name="user.name" v-bind:avatar="user.user_avatar_url"></avatar-bubble>
                  <div class='attendee-name'> 
                    {{ user.name }}
                  </div>
                </div>
              </span>
            </div>

          </div>
          <!-- end 2 column layout -->
          <!-- 1 column layout -->
          <div class='col-sm-12 suite-body' v-if="!showRoomCapacity">
            <div v-html="suiteChatRoom.description" class='p-1 suite-card__description'>
            </div>

            <div class='d-flex flex-column suite-card-attendees-container' v-if='!collapsed'>
              <h4 class="suite-card__attendees-title" v-if="subscribingToPresenceChannel || subscribedToPresenceChannel">{{ lang.get('event_strings.networking-suites.attendees_title') }}</h4>
              <span v-if="subscribingToPresenceChannel">
                {{ lang.get('event_strings.networking-suites.connecting_label') }}
              </span>
              <span v-if="subscribedToPresenceChannel">
                <div class='d-flex align-items-center suite-attendee-item mb-1' v-for="(user, i) in connectedUsers" :key="i">
                  <avatar-bubble v-bind:name="user.name" v-bind:avatar="user.user_avatar_url"></avatar-bubble>
                  <div class='attendee-name'> 
                    {{ user.name }}
                  </div>
                </div>
              </span>
            </div>          

          </div>
          <!-- end 1 column layout -->
        </div>
      </div>
      <div class='col-sm-12 suite-body' v-if="suite.suite_speakers.length > 0 && suite.suite_speakers.some(speakerInRoom => speakerInRoom.room_id === suiteChatRoom.id)">
        <div class="speaker-label  mb-2 suite__item-speakers-section-title"> Speakers :</div>
        <div class="d-flex flex-column">
          <span v-for='speaker in suite.suite_speakers' v-if='speaker.room_id == suiteChatRoom.id' class='mr-2'>
              <div class="speaker-item d-flex align-items-center schedule-item-speakers suites__suite-item-speaker">
                  <div class="suites__suite-item-speaker-avatar mr-2" style="display: inline-block;">
                      <div class="main-stage-agenda__speaker-item-circle rounded-circle d-flex justify-content-center align-items-center text-uppercase" v-bind:style="{ backgroundImage: 'url(' + speaker.event_attendee.attendee_fields.user_avatar_url + ')' }">
                          <span v-if="!speaker.event_attendee.attendee_fields.user_avatar_url && speaker.event_attendee.attendee_fields.first_name[0]" v-html="speaker.event_attendee.attendee_fields.first_name[0]"></span>
                          <span v-if="!speaker.event_attendee.attendee_fields.user_avatar_url && speaker.event_attendee.attendee_fields.last_name[0]" v-html="speaker.event_attendee.attendee_fields.last_name[0]"></span>
                      </div>
                  </div>    
                  <a v-bind:href="'/directories/'+ speaker.directory_id +'/attendee/'+ speaker.event_attendee_id"> {{ speaker.event_attendee.attendee_fields.first_name }} {{ speaker.event_attendee.attendee_fields.last_name }}
                  </a>
              </div>
          </span>
        </div>
      </div>
      <div class='d-flex flex-row'>
        <button class='btn btn-light w-100 m-2 btn-rounded' v-on:click="toggleCollapsed()">
          <span>{{ this.collapsed ? lang.get('event_strings.networking-suites.see_more_button') : lang.get('event_strings.networking-suites.see_less_button') }}</span>
          <i v-if="this.collapsed" class="fal fa-chevron-down"></i>
          <i v-if="!this.collapsed" class="fal fa-chevron-up"></i>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import AvatarBubble from './AvatarBubble.vue'

export default {

  props: ['suite', 'suiteChatRoom' ],

  data() {
    return {
      collapsed: true,
      presenceChannel: null,
      connectedUsers: [],
      fetchingConnectedUsers: false
    }
  },

  watch: {
    collapsed: function () {
      if (this.collapsed) {

        if (this.presenceChannel) {
          this.leavePresenceChannel()
          this.connectedUsers = []
        }
      } else {
        if (this.presenceChannelString) {
          this.presenceChannel = this.joinPresenceChannel()
        }
      }
    }
  },

  computed: {
    progressPercentage: function () {
      return this.suiteChatRoom.active_connections / this.suiteChatRoom.chat_room.max_connections
    },

    presenceChannelString: function () {
      return this.chatRoom && this.chatRoom.presence_channel
    },

    subscribedToPresenceChannel: function () {
      return this.presenceChannel && 
        this.presenceChannel.subscription && 
        this.presenceChannel.subscription.subscribed
    },

    subscribingToPresenceChannel: function () {
      return this.presenceChannel &&
        this.presenceChannel.subscription &&
        this.presenceChannel.subscription.subscriptionPending
    },

    widthStyle: function () {
      var percentage = this.progressPercentage > 1.0 ? 1.0 : this.progressPercentage
      return {
        width: `${percentage * 100}%`
      }
    },

    chatRoom: function () {
      return this.suiteChatRoom.chat_room
    },

    chatRoomAttached: function () {
      return !!this.suiteChatRoom.chat_room
    },

    showRoomCapacity: function () {
      if (!this.suiteChatRoom.chat_room) return false;
      return this.suiteChatRoom.chat_room.max_connections && this.suiteChatRoom.chat_room.limit_connections
    },

    chatRoomLink: function () {
      return `/vmeet/${this.suiteChatRoom.chat_room_id}`
    }
  },

  
  methods:  {

    toggleCollapsed: function () {
      this.collapsed = !this.collapsed
    },

    joinPresenceChannel: function () {
      if (!this.presenceChannelString) return;
      return EchoSpy.join(this.presenceChannelString)
      .here((users) => {
        this.connectedUsers = users.filter(function filterOutSpies (connUser) {
          return !connUser.spy
        })
      }).joining((user) => {
        if (user.spy) return;
        this.connectedUsers.push(user)
      }).leaving((user) => {
        if (user.spy) return;
        this.connectedUsers = this.connectedUsers.filter(function removeLeavingUser(connUser) {
          return connUser.id != user.id
        })
      });
    },

    leavePresenceChannel: function () {
      if (!this.presenceChannelString) return 
      EchoSpy.leave(this.presenceChannelString)
    }
    
  },

};
</script>